/**
 * JWT Token Utilities
 * Helper functions for decoding and inspecting JWT tokens (debugging only)
 */

/**
 * Decode JWT token without verification (for debugging)
 */
export function decodeJWT(token: string): any {
  // Guard clause: return null if token is missing
  if (!token) {
    return null;
  }

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error('Failed to decode JWT:', e);
    return null;
  }
}

/**
 * Check if token is expired or about to expire
 */
export function isTokenExpired(token: string, bufferSeconds = 60): boolean {
  const decoded = decodeJWT(token);
  if (!decoded || !decoded.exp) return true;

  const now = Math.floor(Date.now() / 1000);
  const timeUntilExpiry = decoded.exp - now;

  return timeUntilExpiry <= bufferSeconds;
}
